(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (this.getAttribute('data-sticky-type') === 'none') {
        this.setHeaderHeight();
        this.sizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.sizeObserver.observe(this.header);
        return;
      }
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.mobileViewport = window.matchMedia('(max-width: 989px), (pointer: coarse)');
      this.headerBounds = {};

      this.setHeaderHeight();

      this.onViewportChange = () => {
        this.setHeaderHeight();
        this.currentScrollTop = Math.max(0, window.scrollY);
        if (this.mobileViewport.matches || this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
          this.header.classList.remove('shopify-section-header-hidden', 'animate');
        } else {
          this.reset();
        }
      };
      this.mobileViewport.addEventListener('change', this.onViewportChange);
      this.onViewportChange();
      this.sizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.sizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      const height = this.header.offsetHeight;
      if (height > 0 && height !== this.lastHeaderHeight) {
        this.lastHeaderHeight = height;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    }

    disconnectedCallback() {
      if (this.getAttribute('data-sticky-type') === 'none') {
        this.sizeObserver.disconnect();
        return;
      }
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mobileViewport.removeEventListener('change', this.onViewportChange);
      this.sizeObserver.disconnect();
      window.clearTimeout(this.isScrolling);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.mobileViewport.matches) return;
      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.mobileViewport.matches) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || this.mobileViewport.matches) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || this.mobileViewport.matches) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shejtano-instagram-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.shej-instagram-portfolio').forEach(portfolio => {
    const feed = portfolio.querySelector('.shej-instagram-portfolio__feed');
    const status = portfolio.querySelector('[data-instagram-status]');
    const ready = () => Boolean(feed.querySelector('.gfa-media__source'));
    const prepare = () => {
      feed.querySelectorAll('.gfa-media:not([data-portfolio-ready])').forEach((media, index) => {
        media.dataset.portfolioReady = 'true';
        media.setAttribute('role', 'button');
        media.tabIndex = 0;
        const image = media.querySelector('img');
        media.setAttribute('aria-label', image?.alt || document.querySelector('#shej-instagram-title').textContent);
        if (image) { image.decoding = 'async'; if (index >= 10) image.loading = 'lazy'; }
        media.addEventListener('keydown', event => {
          if (event.target !== media || !['Enter', ' '].includes(event.key)) return;
          event.preventDefault(); media.click();
        });
      });
    };
    const timer = window.setTimeout(() => { status.hidden = ready(); }, 15000);
    const observer = new MutationObserver(() => {
      if (!ready()) return;
      prepare();
      clearTimeout(timer);
      status.hidden = true;
    });
    prepare();
    observer.observe(feed, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => { clearTimeout(timer); observer.disconnect(); }, { once: true });
  });

  } catch(e) { console.error(e); }
})();
})();
